<template>
  <client-only>
    <div class="dashboard-container">
      <admin-header></admin-header>
      <!-- Main Content -->
      <div class="dashboard-content">
        <!-- Side Menu -->
        <side-menu></side-menu>
        <!-- Main Area -->
        <main class="main-area">
          <slot></slot> <!-- This is where your main content will go -->
        </main>
      </div>
    </div>
  </client-only>
</template>
<script setup lang="ts">
import SideMenu from "~/components/core/admin-header/SideMenu.vue";
import AdminHeader from "~/components/core/admin-header/AdminHeader.vue";
import { useUserStore } from "~/composables/useUserStore";
import { onMounted, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
const route = useRoute();
const { setVisiting } = useUserStore();
definePageMeta({
  middleware: 'auth',
  name: 'admin-layout-base'
});

const initialize = () => {
  setVisiting('', null);
};

onMounted(() => {
  initialize();
});

// Watch route changes
watch(() => route.path, () => {
  initialize();
});
const router = useRouter();
// Handle back/forward navigation
router.afterEach((to, from) => {
  console.log('to', to);
  if (!to.path.includes('artist')) {
    initialize();
  }
});
</script>
<style scoped lang="scss">
.dashboard-container {
  display: flex;
  flex-direction: column;
  height: 100vh;
}

.dashboard-header {
  background-color: #3b3b3b;
  color: white;
  padding: 1rem;
  text-align: center;
}

.dashboard-content {
  display: flex;
  flex: 1;
}

.main-area {
  background: $admin-light-white;
  width: calc(100% - 120px);
}
</style>